import React, {useContext, useEffect, useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import $ from "jquery";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import OrgContext from "../../organisation/OrgContext";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import moment from "moment/moment";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {baseURL} from "../../services/api";
import smalLogo from '../../assets/images/ElmanagerLogo.png';
import {
    getEcEco,
    getEcEcoV2,
    getEcFin, getEcFinV2,
    getEcritureComptableEco, getPieceEc,
    getPieceLier, getPieceLierV2
} from "../../helpers/EcritureComptableHeper";
import {formatNumber, isNumeric} from '../../helpers/formater';
import { Document, Page, Text, View, StyleSheet ,Image} from '@react-pdf/renderer';
import { PDFDownloadLink } from '@react-pdf/renderer';

import { frFR, enUS } from '@mui/x-data-grid';
import {LinearProgress} from "@mui/material";
import {exportEc,exportEcPourPiece} from "../../helpers/ExportCsvHelper";
import useAuthHelper from "../../helpers/AuthHelper";

const EcritureComptable = (props) => {
    const {organisation} = useContext(OrgContext);
    const [invoices, setInvoices] = useState([]);
    const [staticInvoices, setStaticInvoices] = useState([]);
    const [invoiceType, setInvoiceType] = useState('');
    const [accounts, setAccounts] = useState([]);
    const [fluxEco, setFluxEco] = useState([]);
    const [loading, setLoading] = useState(0);
    const [loadingFluxFin, setLoadingFluxFin] = useState(0);
    const [invoiceProductExtractedData, setInvoiceProductExtractedData] = useState([]);
    const [fluxFin, setFluxFin] = useState([]);
    const [fluxPiece, setFluxPiece] = useState([]);
    const [invoiceStatusHistory, setInvoiceStatusHistory] = useState([]);
    const [selectedInv, setSelecetdInv] = useState(null);
    const [t, i18n] = useTranslation();

    const [piecetype,setPieceType]=useState(null);

    const[allLoaded, setAllLoaded] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [isPieceEc, setIsPieceEc] = useState(false);
    const {onlyComptable} = useAuthHelper();
    useEffect(() => {
        onlyComptable();
        if (organisation.id) {
            $('.offcanvas').removeClass('show');
            $('.offcanvas').addClass('hide');
            fetchAccounts();
            $('.some-fields-are-required-to-save').css('display', 'none');
            window.$('#staticBackdrop').modal('show');
            getAllInvoices();
        }
    }, []);
    const fetchAccounts = async () => {
        const response = await jwtInterceoptor.get(`/data/user/accounts/${organisation.id}`);

        if (response.status === 200) {
            setAccounts(response.data.data);
            console.log("fetchAccounts: ", response.data.data)
        }
    }
    const getAllInvoices = async () => {
        setLoadingData(true);
        setInvoices([]);
        const response = await jwtInterceoptor.get(`/data/user/factures/getinvoicesforec/${organisation.id}`);

        if (response.status === 200) {
            setInvoices(response.data.data);
            setStaticInvoices(response.data.data);
            console.log("invodsdsdcies: ", response.data.data)
        }
        setLoadingData(false);
    }
    const columns = [
        {
            field: '#',
            headerName: t("Numéro de facture"),
            // remplacer « # » par « Numéro de facture ».
            valueGetter: (params) => {
                if(params.row.journal !== undefined){
                    return "p"+params.row.id;
                }
                return isNumeric(params.row.invoice_number) ? `Fact-${params.row.type}-${formatNumber(params.row.invoice_number)}` : params.row.invoice_number;
            },
            width: 180,
        },
        {
            flex: 1,
            field: 'Client',
            headerName: t("Client")+"/"+t("Fournisseur"),
            valueGetter: (params) =>
                params.row.client!==undefined  ? params.row.client.companyName:"-"
        },
        {
            flex: 1,
            field: '"Date de Facture/La piéce"',
            headerName: t("Date de Facture/La piéce"),
            valueGetter: (params) => `${moment(params.row.created_at).format("DD/MM/YYYY") || ''}`
        },
        {
            flex: 1,
            field: "Montant",
            headerName: t("Montant"),
            valueGetter: (params) => {
                if(params.row.journal !== undefined) {
                    return Number(params.row.total_credit).toFixed(2)+ " "+ organisation?.currency?.code;
                }else{
                    return (params.row.type === 'vente' || params.row.type === 'depense' || params.row.type === 'avoir') ? Number(params.row.total_ttc).toFixed(2) + ` ${organisation?.currency?.code}` : Number(params.row.total_ttc).toFixed(2) + ` ${organisation?.currency?.code}`;
                }
            }
        },

        {
            flex: 1,
            field: "Type",
            headerName: t("Type"),
            valueGetter: (params) => {
                if (params.row.journal !== undefined) {
                    return params.row.journal;
                } else {
                    return params.row.type === 'achat' ? ' Facture lier au stock' : params.row.type === 'avoir' ? 'Facture d\'avoir' : 'Facture de ' + params.row.type;
                }
            }
        },
        {
            flex: 1,
            field: "Action",
            headerName: t("Action"),
            renderCell: (params) => {
                const getEc = (e) => {
                    setFluxPiece([]);
                    const inv = params.row;

                    console.log("getEc.inv", inv)
                    setAllLoaded([]);
                    setSelecetdInv(inv);
                    const id = toast.loading(
                        "chargement....", {
                            position: "top-right",
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            pauseOnFocusLoss:false,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            autoClose:50
                        });

                        
                    if( inv.journal!==undefined ){
                        setAllLoaded((init) => [...init, 1]);
                        setAllLoaded((init) => [...init, 1]);
                        setAllLoaded((init) => [...init, 1]);

                        let flux = getPieceEc(inv);
                        setFluxPiece([flux]);
                        setIsPieceEc(true);
                        setFluxFin([])
                        setFluxEco([])


                        setLoading(0);
                    }else{
                        if (inv.type === "avoir") {
                            getPaymentFactAvoir(inv).then(() => {
                                // Les autres fonctions sont exécutées après getPaymentFactAvoir
                                setFluxPiece([]);
                                setIsPieceEc(false);
                                getEcritureComptableEco(inv);
                                getEcLierALaPiece(inv);
                                getEcritureComptableFin(inv);
                                console.log(fluxFin);
                            });
                        } else {
                            // Si ce n'est pas une facture "avoir", exécuter directement les autres fonctions
                            setSelecetdInv(inv);
                            setFluxPiece([]);
                            setIsPieceEc(false);
                            getEcritureComptableEco(inv);
                            getEcLierALaPiece(inv);
                            getEcritureComptableFin(inv);
                            console.log(fluxFin);
                        }
                        
                    }

                    toast.update(id, {
                        render: "Chargement de l'écriture a été fait avec succès.",
                        type: "success",
                        isLoading: false,
                        autoClose: 2000,
                        pauseOnFocusLoss: false,
                        closeOnClick: true
                    });
                    
                }
                return (
                    <div className="btn-list">
                        <a data-bs-toggle="offcanvas" href="#offcanvasExample" role="button"
                           aria-controls="offcanvasExample" onClick={getEc} id="bEdit"
                           className="btn  btn-sm btn-secondary">
                            <span class="fe fe-eye"> </span>
                        </a>
                    </div>
                );
            }
        }

    ];
    const getPaymentFactAvoir = (invoice) => {
        setLoading(1); // Indiquer que le chargement est en cours
        console.log(invoice.facture_vente_id);
    
        const id = invoice.facture_vente_id;
    
        // Retourner la promesse pour permettre l'utilisation de .then
        return jwtInterceoptor
            .get(`${baseURL}/data/user/invoice_status_history/${id}`)
            .then((response) => {
                if (response.data) {
                    invoice.payment = response.data.data; // Mettre à jour l'objet invoice avec les données reçues
                    setSelecetdInv(invoice);
                } else {
                    console.warn("Aucune donnée de paiement trouvée pour l'ID :", id);
                }
                setLoading(0); // Fin du chargement
            })
            .catch((error) => {
                console.error("Erreur lors de la récupération des données de paiement :", error);
                setLoading(0); // Fin du chargement même en cas d'erreur
            });
    };
    
    
    
    

    const getEcritureComptableEco = async (invoice) => {
        console.log("single invoice: ", invoice)
        setLoading(1);

        //v2
        setFluxEco([getEcEcoV2(invoice)])
        setLoading(0);
        setAllLoaded((init) => [...init, 1]);

    }

    const getEcLierALaPiece = (invoice) => {
        setFluxPiece([getPieceLierV2(invoice)]);

        setAllLoaded((init) => [...init, 2]);

        // getPieceLier(invoice)
        //     .then(flux => {
        //         setFluxPiece([flux])
        //         setAllLoaded((init) => [...init, 2]);
        //         console.log("setFluxPiece: ", [flux])
        //     })
        //     .catch(error => {
        //         console.log("error while returing ec setFluxPiece : ", error)
        //     });
    }

    const getEcritureComptableFin = async (invoice) => {
        setLoadingFluxFin(1);
        setFluxFin(getEcFinV2(invoice))
        setLoadingFluxFin(0);
        setAllLoaded((init) => [...init, 3]);
        console.log("flux Fin",fluxFin)

        // getEcFin(invoice)
        //     .then(flux => {
        //         setFluxFin(flux)
        //         setLoadingFluxFin(0);
        //         setAllLoaded((init) => [...init, 3]);
        //     })
        //     .catch(error => {
        //         console.log("error while returing ec fluxfin : ", error)
        //     });
    }

    const getTvaAndAccounts = (invoiceProducts) => {
        let invoiceTvas = [];
        let InvoiceAccounts = [];
        for (let i = 0; i < invoiceProducts.length; i++) {
            InvoiceAccounts.push(invoiceProducts[i]['product']['purchase_account']['code']);
            invoiceTvas.push(invoiceProducts[i]['product']['taxe_achat']['code']);
        }

        return [
            invoiceTvas,
            InvoiceAccounts
        ];
    }
    const invoiceProducts = (invoice) => {

    }
    const filter = async () => {
        if (
            invoiceType === '0' || invoiceType === '' || (invoiceType==="piece" && (piecetype==="" || piecetype==="0") )
        ) {
            /**
             *
             * @type {string}
             */
            let errorMessage = "le Type de facture est obligatoire";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {
            /**
             *
             * @type {*[]}
             */
            let res = [];
            if (invoiceType === 'achat'){
                res = staticInvoices.filter((invoice) => invoice.type === 'achat' || invoice.type === 'depense');
            }else if(invoiceType === 'avoir'){
                res = staticInvoices.filter((invoice) => invoice.type === 'avoir');
            }else if(invoiceType === 'vente'){
                res = staticInvoices.filter((invoice) => invoice.type === 'vente');
            }else{
                res = staticInvoices.filter((invoice) => invoice.journal === piecetype);
            }

            console.log("res; ", res)
            setInvoices(res);
            window.$('#staticBackdrop').modal('hide');
        }
    }

    // Create styles
    const styles = StyleSheet.create({
        page: {
        // flexDirection: 'row',
        // backgroundColor: '#E4E4E4'
        },
        section: {
            margin: 10,
            padding: 10,
            fontSize: 11,
            //flex: 1,
            // flexGrow: 1,

        },
        header: {
            flexDirection: "row",
            marginBottom: 12,
            borderWidth: 1
        },
        cell: {
            borderRightWidth: 1,
            justifyContent: "center",
            alignItems: "center",
            minHeight: 25
        },
        cellRow: {
            minHeight: 25,
            padding: 5,
            paddingTop: 7
        },
        textHeader: {
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "center"
        },
        row: {
            flexDirection: "row",
        },
        textRow: {
            fontSize: 9.5
        },
        headerPage: {
            flexDirection: "row",
            padding: 5,
            borderWidth: 1.5,
            marginBottom: 5
        },
        leftSide: {
            flex: 1,
            justifyContent: "space-between"
        },
        centerContainer: {
            flex: 1,
            justifyContent: "space-between",
            alignItems: "center"
        },
        rightSide: {
            flex: 1,
            justifyContent: "flex-end",
            paddingLeft: 40
        }
    });

    // Export to PDF
    const ExportEC = ({dataFluxEco=[], dataFluxPiece=[], dataFluxFin=[]}) => {
        let date_now = new Date();
        let copyIcon = ' © ';
        var FcDate = new Date(selectedInv?.created_at);
        let total_debit_fEq = 0;
        let total_credit_fEq = 0;
        let total_debit_fFn = 0;
        let total_credit_fFn = 0;
        return(
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.section}>
                    <View style={styles.headerPage}>
                            <View style={styles.leftSide}>
                                <Text>{organisation?.name}</Text>
                                <Text>Impression provisoire</Text>
                            </View>
                            <View style={styles.centerContainer}>
                            <Image style={{width:40,height:30}} src={smalLogo}></Image>
                                <Text style={{textAlign: "center", fontSize: 18, fontWeight: "bold", marginBottom: 6}}>écriture comptable</Text>
                                <View style={{flexDirection: "row"}}>
                                    <Text style={{marginRight: 30, fontSize: 11.5}}>{selectedInv?.type == "achat" ? "Facture d'achat" : selectedInv?.type === "avoir" ? "Facture d'avoir" : "Facture de vente"}</Text>
                                    <View>
                                        <Text style={{fontSize: 11.5}}>N° {isNumeric(selectedInv?.invoice_number) ? ('Fact-'+selectedInv?.type+'-'+formatNumber(selectedInv?.invoice_number)) : selectedInv?.invoice_number}</Text>
                                    </View>
                                </View>
                            </View>
                            <View style={styles.rightSide}>
                                <View style={{flexDirection: "row", justifyContent: "flex-end"}}>
                                    <Text style={{textAlign: "right", marginRight: 4}}>Date Facture : </Text>
                                    <Text style={{textAlign: "right"}}>{moment(FcDate).format("DD/MM/YYYY")}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.headerPage, {border: 0, padding: 0}]}>
                            <View style={styles.leftSide}>
                                <Text style={{fontSize: 9}}>{copyIcon}<Text style={{htmlContnet: '\\00A9'}}></Text>{"ELMANAGER CLOUD"}</Text>
                            </View>
                            <View style={[{justifyContent: "flex-end"}]}>
                                <View style={{flexDirection: "row", alignItems: "flex-end"}}>
                                    <Text style={{textAlign: "right", marginRight: 4}}>Date de tirage : </Text>
                                    <Text style={{textAlign: "right"}}>{date_now?.getDate()}/{date_now?.getMonth()+1}/{date_now?.getFullYear()} à {date_now?.getUTCHours()+1}:{date_now?.getMinutes() < 10 ? "0"+date_now?.getMinutes() : date_now?.getMinutes()}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.header}>
                            <View style={[styles.cell, {flex: 2}]}><Text style={styles.textHeader}>Date</Text></View>
                            <View style={[styles.cell, {flex: 2}]}><Text style={styles.textHeader}>N° pièce</Text></View>
                            <View style={[styles.cell, {flex: 2}]}><Text style={styles.textHeader}>N° compte</Text></View>
                            <View style={[styles.cell, {flex: 3}]}><Text style={styles.textHeader}>Sous Compte</Text></View>
                            <View style={[styles.cell, {flex: 3}]}><Text style={styles.textHeader}>Libellé écriture</Text></View>
                            <View style={[styles.cell, {flex: 3}]}><Text style={styles.textHeader}>Débit</Text></View>
                            <View style={[styles.cell, {flex: 3, borderRightWidth: 0}]}><Text>Crédit</Text></View>
                        </View>
                        <View style={{border: 1,}}>
                            {
                                !isPieceEc ?
                                <View key={Math.random()}  style={styles.row}>
                                    <View style={[styles.cellRow, {flex: 12, paddingRight: 45}]}>
                                    <Text style={[styles.textRow, {fontWeight: "bold"}]}>Flux économique</Text>
                                    </View>
                                    <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}></View>
                                    <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}></View>
                                </View>
                                :null
                            }
                            {

                                dataFluxEco.map((flux) =>
                                {
                                    total_credit_fEq += flux.invoice_type != 'vente' ? parseFloat(flux.total_ttc) : 0;
                                    total_debit_fEq += flux.invoice_type == 'vente' ? parseFloat(flux.total_ttc) : 0;
                                    return (<View key={Math.random()} style={styles.row}>
                                        <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}>{flux.date_creation}</Text></View>
                                        <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}>{flux.no_piece}</Text></View>
                                        <View style={[styles.cellRow, {flex: 2}]}>
                                            <Text style={styles.textRow}>{flux.compte_fournisseur}</Text>
                                            {
                                                flux.compte_tva?.map((tva) => {
                                                    return (<Text style={styles.textRow}>{tva}</Text>);
                                                })
                                            }
                                            {
                                                flux?.compte_compte_de_charge?.map((compte_de_charge) => {
                                                    return (
                                                        <Text style={styles.textRow}>{compte_de_charge}</Text>);
                                                })
                                            }
                                        </View>
                                        <View style={[styles.cellRow, {flex: 3}]}><Text style={styles.textRow}>{flux.sous_compte}</Text></View>
                                        <View style={[styles.cellRow, {flex: 3}]}><Text style={styles.textRow}>{flux.libelle_fournisseur}</Text></View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                            {flux.invoice_type === 'vente' ? <Text style={[styles.textRow, { textAlign: "right" }]}>{Number(flux.total_ttc).toFixed(2) }</Text>  :
                                                flux?.total_ht_et_tva?.map((total_ht_et_tva, elt = 0) => {
                                                    total_debit_fEq += total_ht_et_tva != "<br />" ? parseFloat(total_ht_et_tva) : 0;
                                                    console.log(total_ht_et_tva);
                                                    if (elt === 0) {
                                                        elt++;
                                                        return (<Text style={[styles.textRow, { textAlign: "right" }]}>{"\n"}</Text>);
                                                    }
                                                    return (<Text style={[styles.textRow, { textAlign: "right" }]}>{Number(total_ht_et_tva).toFixed(2) }</Text>);
                                                })
                                            }
                                        </View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                            {flux.invoice_type === 'vente' ?
                                                flux?.total_ht_et_tva?.map((total_ht_et_tva, elt = 0) => {
                                                    total_credit_fEq += total_ht_et_tva != "<br />" ? parseFloat(total_ht_et_tva) : 0;
                                                    if (elt === 0) {
                                                        elt++;
                                                        return (<Text style={[styles.textRow, { textAlign: "right" }]}>{"\n"}</Text>);
                                                    }
                                                    return (<Text style={[styles.textRow, { textAlign: "right" }]}>{ Number(total_ht_et_tva).toFixed(2) }</Text>);
                                                })
                                                : <Text style={[styles.textRow, { textAlign: "right" }]}>{Number(flux.total_ttc).toFixed(2)}</Text> }
                                        </View>
                                    </View>)
                                })
                            }
                            {
                                dataFluxPiece[0] === null ? null : dataFluxPiece.map((flux) => {
                                    flux.credit[0].map((c) => {
                                        total_credit_fEq += parseFloat(c);
                                    })
                                    flux.debit[0].map((c) => {
                                        total_debit_fEq += parseFloat(c);
                                    })
                                    return (<View key={Math.random()}  style={styles.row}>
                                        <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}>{flux.date_creation}</Text></View>
                                        <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}>{flux.no_piece}</Text></View>
                                        <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}>{flux.compte_fournisseur}</Text>

                                            {flux.accounts[0].map((account) => {
                                                    return (<Text style={styles.textRow}>{account}</Text>);
                                                })
                                            }
                                        </View>
                                        <View style={[styles.cellRow, {flex: 3}]}><Text style={styles.textRow}>{"-"}</Text></View>
                                        <View style={[styles.cellRow, {flex: 3}]}><Text style={styles.textRow}>{flux.libelle_fournisseur}</Text></View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                            <Text style={styles.textRow}>{flux.libelle_fournisseur==="-" ? "\n":null}</Text>
                                            {
                                                flux.debit[0].map((d) => {
                                                    return (<Text style={[styles.textRow, { textAlign: "right" }]}>{Number(d).toFixed(2) }</Text>);
                                                })
                                            }
                                        </View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                            <Text style={styles.textRow}>{flux.libelle_fournisseur==="-" ? "\n":null}</Text>
                                            {
                                                flux.credit[0].map((c) => {
                                                    return (<Text style={[styles.textRow, { textAlign: "right" }]}>{Number(c).toFixed(2) }</Text>);
                                                })
                                            }

                                        </View>
                                    </View>)
                                })
                            }

                            {
                                !isPieceEc ?
                                    <View key={Math.random()} style={styles.row}>
                                        <View style={[styles.cellRow, {flex: 12, paddingRight: 45}]}>
                                            <Text style={[styles.textRow, {fontWeight: "bold"}]}>Flux financier</Text>
                                        </View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}></View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}></View>
                                    </View>:null
                            }

                            {

                                dataFluxFin.map((f) =>
                                {
                                    total_credit_fFn += parseFloat(f.total_ttc);
                                    total_debit_fFn += parseFloat(f.total_ttc);
                                    return (<View key={Math.random()}  style={styles.row}>
                                        <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}>{f.date_creation}</Text></View>
                                        <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}>{f.no_piece}</Text></View>
                                        <View style={[styles.cellRow, {flex: 2}]}>
                                            <Text style={styles.textRow}>{f.compte_fournisseur}</Text>
                                            <Text style={styles.textRow}>{f.payment_account}</Text>
                                            <Text style={styles.textRow}>{f.banquePaymentOption === null ? "" : f.banquePaymentOption + (f.chequeId === null ? "" : ' - ' + f.chequeId)}</Text>
                                            <Text style={styles.textRow}>{"\n"}</Text>
                                        </View>
                                        <View style={[styles.cellRow, {flex: 3}]}><Text style={styles.textRow}>{f.sous_compte}</Text></View>
                                        <View style={[styles.cellRow, {flex: 3}]}><Text style={styles.textRow}>{f.banquePaymentOption === null ? f.libelle_fournisseur : f.banquePaymentOption + (f.chequeId === null ? "" : ' - ' + f.chequeId)}</Text></View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                        {f.invoice_type === 'vente' ?
                                                                        <Text style={[styles.textRow, { textAlign: "right" }]}><Text style={styles.textRow}>{"\n"}</Text>{Number(f.total_ttc).toFixed(2) }</Text>:
                                                                        <Text style={[styles.textRow, { textAlign: "right" }]}>{Number(f.total_ttc).toFixed(2)}</Text>}
                                        </View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                            {f.invoice_type === 'vente' ?  <Text style={[styles.textRow, { textAlign: "right" }]}>{Number(f.total_ttc).toFixed(2)}</Text> :
                                                                    <Text style={[styles.textRow, { textAlign: "right" }]}><Text style={styles.textRow}>{"\n"}</Text>{Number(f.total_ttc).toFixed(2)}</Text>}
                                        </View>
                                    </View>)
                                })
                            }

                            {
                                isPieceEc?
                                    <View style={[styles.row, {borderTopWidth: 1}]} >
                                        <View style={[styles.cellRow, {flex: 12, paddingRight: 45}]}><Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>Total du flux</Text></View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                            <Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>
                                                {Number(total_debit_fEq).toFixed(2)}
                                            </Text>
                                        </View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                            <Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>
                                                {Number(total_credit_fEq).toFixed(2)}
                                            </Text>
                                        </View>
                                    </View>:null
                            }
                            {
                                !isPieceEc?<View style={[styles.row, {borderTopWidth: 1}]} >
                                    <View style={[styles.cellRow, {flex: 12, paddingRight: 45}]}><Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>Total Flux économique</Text></View>
                                    <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                        <Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>
                                            {Number(total_debit_fEq)>Number(total_credit_fEq)?Number(total_debit_fEq).toFixed(2):Number(total_credit_fEq).toFixed(2)}
                                        </Text>
                                    </View>
                                    <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                        <Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>
                                        {Number(total_debit_fEq)>Number(total_credit_fEq)?Number(total_debit_fEq).toFixed(2):Number(total_credit_fEq).toFixed(2)}
                                        </Text>
                                    </View>
                                </View>:null
                            }

                            {
                                !isPieceEc ? <View style={[styles.row, {borderTopWidth: 1}]} >
                                    <View style={[styles.cellRow, {flex: 12, paddingRight: 45}]}><Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>Total Flux financier</Text></View>
                                    <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                        <Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>
                                            {Number(total_debit_fFn).toFixed(2)}
                                        </Text>
                                    </View>
                                    <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                        <Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>
                                            {Number(total_credit_fFn).toFixed(2)}
                                        </Text>
                                    </View>
                                </View>:null
                            }
                           
                        </View>

                    </View>
                </Page>
            </Document>
        )
    };

    const exportCsvEc = ()=>{

        let header = "";

        let result=false;
        if(isPieceEc){
            header = "écriture comptable pour journal "+piecetype;
            result=exportEcPourPiece(fluxPiece,header)
        }
        else{
            header = "écriture comptable de la facture : Fac-" + selectedInv.type + "-" + formatNumber(selectedInv.id);
            result=exportEc(fluxEco,fluxFin,fluxPiece,header);
        }

        if(result){
            toast.success('Exportation Csv générer avec succéess', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }else{
            toast.error('Une erreur s\'est produite lors de l\'exportation du fichier CSV', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }

    return (
        <>
            <ToastContainer/>
            <div className="container-fluid">
                <div className="row" style={{zIndex: 1}}>
                    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false"
                         tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h1 class="modal-title fs-5"
                                        id="staticBackdropLabel">{t('Filtrer les écriture comptable')}</h1>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                    <div
                                        class="alert alert-danger alert-dismissible fade show mb-0 some-fields-are-required-to-save"
                                        role="alert">
                                <span
                                    class="alert-inner--icon"><i class="fe fe-slash"></i></span><span
                                        class="alert-inner--text"><strong></strong>Attention ! Les champs suivants sont obligatoire.</span>
                                        <p>
                                            - L'état de la factrue <br/>
                                            - Mode de réglement <br/>
                                            - Type de facture <br/>
                                        </p>
                                        <button type="button" className="btn-close" data-bs-dismiss="alert"
                                                aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="exampleInputEmail1" className="">Type d'écriture*</label>
                                        <select className="form-select" id="buyPriceAccountInput"
                                                onChange={(e) => {
                                                    setInvoiceType(e.target.value);
                                                    setPieceType(null);
                                                }} value={invoiceType}>
                                            <option value="0">selectionner un type d'écriture</option>
                                            <option value="achat">Facture d'achat</option>
                                            <option value="vente">Facture de vente</option>
                                            <option value="avoir">Facture d'avoir</option>
                                            <option value="pieces">Piéce</option>
                                        </select>

                                        <div className="form-group" style={{display: invoiceType === "pieces" ? "block" : "none"}}>
                                            <br/>
                                            <label htmlFor="exampleInputEmail1" className="">Journal*</label>
                                            <select className="form-select" id="buyPriceAccountInput"
                                                    onChange={(e) => setPieceType(e.target.value)} value={piecetype}
                                                    >
                                                <option value="0">selectionner un type de facture</option>
                                                <option value="Operation Diverses">Operation Diverses</option>
                                                <option value="Report à Nouveaux">Report à Nouveaux</option>
                                                <option value="Banque">Banque</option>
                                                <option value="Caisse">Caisse</option>
                                            </select>
                                        </div>

                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => {
                                        getAllInvoices();
                                        window.$('#staticBackdrop').modal('hide');
                                    }
                                    }>{t('Afficher tout')}
                                    </button>
                                    <button type="button" className="btn btn-primary"
                                            onClick={() => filter()}>{t('Enregistrer')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div class="page-header">
                            <h1 class="page-title breadcumpsHeader">Ecriture Comptable</h1>

                        </div>
                    </div>
                    <div className="card">
                        <div class="mt-4 mb-4 mx-4 text-right">
                            <a className="btn btn-primary" onClick={() => {
                                window.$('#staticBackdrop').modal('show');
                            }
                            }>
                                {t('Filtrer à nouveaux')}
                            </a>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <div style={{height: 600, width: '100%'}}>
                                    <DataGrid
                                        rows={invoices}
                                        columns={columns}
                                        pagination={false}
                                        localeText={
                                            i18n.language == "fr" ?
                                                frFR.components.MuiDataGrid.defaultProps.localeText :
                                                enUS.components.MuiDataGrid.defaultProps.localeText
                                        }
                                        getRowId={(row) => `${row.type}-${row.id}`}
                                        slotProps={{
                                            toolbar: {
                                                printOptions: { disableToolbarButton: true },
                                                csvOptions: { disableToolbarButton: true },
                                            }}
                                        }
                                        slots={{
                                            toolbar: GridToolbar,
                                            loadingOverlay: LinearProgress,
                                        }}
                                        loading={loadingData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="offcanvas offcanvas-start cutomWith" tabIndex="-1" id="offcanvasExample"
                     aria-labelledby="offcanvasExampleLabel">
                    <div class="offcanvas-header">
                        <h5 class="offcanvas-title" id="offcanvasExampleLabel">écriture comptable</h5>
                        <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas"
                                aria-label="Close"><i class="fe fe-x fs-18"></i></button>
                    </div>
                    <div class="offcanvas-body">
                        <div className='row'>
                            <div className='col-md-4'>
                                {allLoaded.length === 3  ? (
                                    <PDFDownloadLink
                                        document={<ExportEC 
                                            dataFluxEco={[...fluxEco]}
                                            dataFluxPiece={[...fluxPiece]}
                                            dataFluxFin={[...fluxFin]} 
                                        />}
                                        fileName={`ec-facture-${selectedInv?.type == "achat" ? "achat" : selectedInv?.type === "avoir" ? "avoir" : "vente"}-${selectedInv?.invoice_number}.pdf`}
                                        className='btn btn-info'
                                        style={{height: 38}}
                                    >

                                        {({ blob, url, loading, error }) =>
                                        loading ? t("Loading document...") : <><span className="fe fe-download"> </span> {t("PDF")}</>
                                        }
                                    </PDFDownloadLink>
                                ): null}
                            </div>
                            <div className='col-md-4'>
                                <button onClick={exportCsvEc} className={'btn btn-info'} style={{height: 38}}><span className="fe fe-download">{t("CSV")}</span></button>
                            </div>

                        </div>
                        <br/>
                        <div className="elt1">
                            <div style={ {display: !isPieceEc ?"block":"none"} }>
                                <h1><strong>{t('Flux économique')}</strong></h1>
                            </div>
                            <div>

                                <table className="table tableec" style={{display: loading === 0 ? 'block' : 'none'}}>
                                    <thead className={"table-primary"}>
                                    <tr>
                                        <th scope="col">date d'opération</th>
                                        <th scope="col">n° piéce</th>
                                        <th scope="col">n° de facture</th>
                                        <th scope="col">N° compte</th>
                                        <th scope="col">sous compte</th>
                                        <th scope="col">libellé écriture</th>
                                        <th scope="col">débit</th>
                                        <th scope="col">crédit</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {
                                        fluxEco.map(
                                            (flux) => {
                                                return (
                                                    <tr>
                                                        <th scope="col">{flux.date_creation}</th>
                                                        <th scope="col">{flux.no_piece}</th>
                                                        <th scope="col">{flux.invoice_number}</th>
                                                        <th scope="col">
                                                            <span>{flux.compte_fournisseur}</span><br/>
                                                            {
                                                                flux.compte_tva.map((tva) => {
                                                                    return (<span>{tva}<br/></span>);
                                                                })
                                                            }
                                                            {
                                                                flux.compte_compte_de_charge.map((compte_de_charge) => {
                                                                    return (<span>{compte_de_charge}<br/></span>);
                                                                })
                                                            }
                                                        </th>
                                                        <th scope="col">{flux.sous_compte}</th>
                                                        <th scope="col">{flux.libelle_fournisseur}</th>

                                                        <th scope="col">{flux.invoice_type === 'vente' ? Number(flux.total_ttc).toFixed(2) :
                                                            flux.total_ht_et_tva.map((total_ht_et_tva, elt = 0) => {
                                                                if (elt === 0) {
                                                                    elt++;
                                                                    return (<div><br/></div>);
                                                                }
                                                                return (<div> {Number(total_ht_et_tva).toFixed(2)} </div>);
                                                            })
                                                        }</th>
                                                        <th scope="col">{flux.invoice_type === 'vente' ?
                                                            flux.total_ht_et_tva.map((total_ht_et_tva, elt = 0) => {
                                                                if (elt === 0) {
                                                                    elt++;
                                                                    return (<div><br/></div>);
                                                                }
                                                                return (<div> {Number(total_ht_et_tva).toFixed(2)} </div>);
                                                            })
                                                            : Number(flux.total_ttc).toFixed(2)}</th>
                                                    </tr>
                                                );
                                            }
                                        )
                                    }
                                    {
                                        fluxPiece[0] === null ? null :

                                            fluxPiece.map(
                                                (fluxPiece) => {
                                                    return (
                                                        <tr>
                                                            <th scope="col">{fluxPiece.date_creation}</th>
                                                            <th scope="col">{fluxPiece.no_piece}</th>
                                                            <th scope="col">
                                                                <div>{fluxPiece.compte_fournisseur}</div>
                                                                <div>
                                                                    {fluxPiece.accounts[0].map((account) => {
                                                                        return (<div> {account} </div>);
                                                                    })
                                                                    }
                                                                </div>
                                                            </th>
                                                            <th scope="col">{'-'}</th>
                                                            <th scope="col">{fluxPiece.libelle_fournisseur}</th>
                                                            <th scope="col">
                                                                { fluxPiece.libelle_fournisseur==="-"? (<p></p>):null }
                                                                <div>
                                                                    {
                                                                        fluxPiece.debit[0].map((d) => {
                                                                            return (<div> {Number(d).toFixed(2)} </div>);
                                                                        })
                                                                    }
                                                                </div>
                                                            </th>
                                                            <th scope={"col"}>
                                                                { fluxPiece.libelle_fournisseur==="-"? (<p></p>):null }
                                                                <div>
                                                                    {
                                                                        fluxPiece.credit[0].map((c) => {
                                                                            return (<div> {Number(c).toFixed(2)} </div>);
                                                                        })
                                                                    }
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    );
                                                }
                                    )
                                    }
                                    </tbody>
                                </table>

                                <center>
                                    <div class="spinner-border text-primary me-2" role="status"
                                         style={{display: loading === 1 ? 'block' : 'none'}}>
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </center>
                            </div>
                        </div>

                        <div className="elt2" style={ {display: !isPieceEc ?"block":"none"} }>
                            <div>
                                <h1><strong>{t('Flux financier')}</strong></h1>
                            </div>
                            <div>
                                <table className="table" style={{display: loadingFluxFin === 0 ? 'block' : 'none'}}>
                                    <thead className={"table-primary"}>
                                    <tr>
                                        <th scope="col">date d'opération</th>
                                        <th scope="col">n° piéce</th>
                                        <th scope="col">n° de facture</th>
                                        <th scope="col">N° compte</th>
                                        <th scope="col">sous compte</th>
                                        <th scope="col">libellé écriture</th>
                                        <th scope="col">débit</th>
                                        <th scope="col">crédit</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        fluxFin.map(
                                            (f) => {
                                                return (
                                                    <tr>
                                                        <th scope="col">{f.date_creation}</th>
                                                        <th scope="col">{f.no_piece}</th>
                                                        <th scope="col">{f.invoice_number}</th>
                                                        <th scope="col">
                                                            <span>{f.compte_fournisseur}</span><br/>
                                                            <span>{f.payment_account}</span><br/>
                                                            <span>{f.banquePaymentOption === null ? "" : f.banquePaymentOption + ((f.chequeId === null || f.chequeId === '') ? "" : ' - ' + f.chequeId)}</span><br/>
                                                            <br/>
                                                        </th>
                                                        <th scope="col">{f.sous_compte}</th>
                                                        <th scope="col">{f.banquePaymentOption === null ? f.libelle_fournisseur : f.banquePaymentOption + ((f.chequeId === null || f.chequeId === '') ? "" : ' - ' + f.chequeId)}</th>

                                                        <th scope="col">{f.invoice_type === 'vente' ?
                                                            <span> <br/> {Number(f.total_ttc).toFixed(2)} </span> :
                                                            <span> {Number(f.total_ttc).toFixed(2)} </span>}</th>
                                                        <th scope="col">{f.invoice_type === 'vente' ? Number(f.total_ttc).toFixed(2) :
                                                            <span> <br/> {Number(f.total_ttc).toFixed(2)} </span>}</th>

                                                    </tr>
                                                );
                                            }
                                        )
                                    }
                                    </tbody>
                                </table>
                                <center>
                                    <div class="spinner-border text-primary me-2" role="status"
                                         style={{display: loadingFluxFin === 1 ? 'block' : 'none'}}>
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </>
    );
}

    export default EcritureComptable;